import {
  withFirebase,
  firebaseConnect} from 'react-redux-firebase'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { styles } from '../../containers/dockPadStyle'
import {  getProjectId } from '../../selectors/project.selector'
import PPCReportScreen from './PPCReportScreen'
import { lookaheadActions } from '../../actions/lookahead.actions'
import { getSelectedCommitmentId, hasCommitments, getSimpleCommitment, getLookaheadCommitmentList, getSelectedCommitment, getSelectedLookaheadId, getLookaheadTags, getPPCPerTrade, lookaheadTagFBConnect, getSelectedCommitmentLog, getLookaheadTrades } from '../../selectors/lookahead.selector'
import { ThunkDispatch } from 'redux-thunk'

const mapStateToProps = (state: any) => ({
    selectedCommitment: getSelectedCommitment(state),
    commitmentList: getLookaheadCommitmentList(state),
    tags: getLookaheadTags(state),
    ppcPerTrade: getPPCPerTrade(state),
    hasCommitments: hasCommitments(state),
    simpleCommitments: getSimpleCommitment(state),
    commitmentLog: getSelectedCommitmentLog(state),
    trades:  getLookaheadTrades(state),

    
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return {
        showDeletePPCDialog: (commitmentId: string) => dispatch(lookaheadActions.showDeletePPCDialog(commitmentId)),
        updatePPCSelectedCommitment: (commitmentId: string) => dispatch(lookaheadActions.selectPPCCommitment(commitmentId))
    }
}

export default compose(
    withRouter,
    withFirebase,
    connect(state => {
        return {
            projectId: getProjectId(state),
            commitmentId: getSelectedCommitmentId(state),

            lookaheadId: getSelectedLookaheadId(state)
        };
    }),
    firebaseConnect((props: any) => {

        if (!props.projectId || !props.commitmentId || !props.lookaheadId) {
            return []
        }

        return [
            {
                path: `/projects/${props.projectId}/lookahead_commitments/${props.lookaheadId}/commitments/${props.commitmentId}`,
                storeAs: 'SELECTED_COMMITMENT'
            },
            {
                path: `projects/${props.projectId}/lookaheads/${props.lookaheadId}/tags`,
                storeAs: 'SELECTED_LOOKAHEAD_TAGS'
            }
        ];
    }),
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true })
  )(PPCReportScreen)


// WEBPACK FOOTER //
// ./src/components/PPC_Reports/PPCReportContainer.ts